<template>
  <div class="main-category mb-4">
    <div class="d-flex align-items-center">
      <p class="title">{{ userGroup.groupName }}</p>
      <font-awesome-icon icon="fa-solid fa-ellipsis" class="options-icon" @click="toggleOpen" />
    </div>
    <div v-show="isOpen" class="options-container">
      <div class="options-item edit" @click="handleDownload">
        <div class="d-flex align-items-center">
          <font-awesome-icon icon="fa-solid fa-download" class="list-icon mx-3" />
          Címlista letöltése
        </div>
      </div>
      <div class="options-item edit" @click="goToEdit">
        <div class="d-flex align-items-center">
          <font-awesome-icon icon="fa-solid fa-pencil" class="list-icon mx-3" />
          Szerkesztés
        </div>
      </div>
      <div class="options-item delete" @click="openDeleteModal">
        <div class="d-flex align-items-center">
          <font-awesome-icon icon="fa-solid fa-trash" class="list-icon mx-3" />
          Törlés
        </div>
      </div>
    </div>

    <b-modal :id="`${userGroup._id}-delete-user-group-modal`" hide-header hide-footer title="" size="xl">
      <div class="d-block mb-5 p-2 pt-0 ">
        <h1 class="d-flex justify-content-center text-center mb-5">
          <strong> Biztos benne, hogy törölni szeretné a címzett csoportot?</strong>
        </h1>

        <div class="d-flex justify-content-center">
          <b-button class="mr-2" @click="closeDeleteModal">Mégsem</b-button>
          <b-button class="ml-2" variant="primary" @click="handleDelete">Csoport törlése</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import * as systemEmailsApi from '../../../api/systemEmail'
import errorToast from '../../../mixins/toastError'
import successToast from '../../../mixins/toastSuccess'
export default {
  mixins: [successToast, errorToast],
  props: {
    userGroup: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },

  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    async handleDownload() {
      const data = await this.getUserData()
      const BOM = '\uFEFF'

      const csvdata = BOM + this.csvMaker(data)

      this.download(csvdata)
      this.toggleOpen()
    },
    async getUserData() {
      try {
        const result = await systemEmailsApi.getUsersByEmailFilters(this.userGroup.emailFilters)

        return result
      } catch (error) {
        this.toggleOpen()
        return this.errorToast('Az adott csoport feltételei alapján nem találtunk felhasználót.')
      }
    },
    goToEdit() {
      this.$router.push(`/system-email/create-group?groupId=${this.userGroup._id}`)
    },
    csvMaker(dataArray) {
      if (dataArray.length > 0) {
        const csvRows = []

        const headerRow = `"Ügyfél neve","Ügyfél regisztrált e-mail címe","Címzett neve megszólítással","Vállalkozás(ok) neve","Hírlevél azonosító","Hírlevél leiratkozó link"`
        csvRows.push(headerRow)

        dataArray.map(data => {
          const sanitizedCompanyNames = data.companyNames.map(name => name.replace(/['"]/g, '')).join(',')
          const row = `"${data.fullName}","${data.email}","${data.adressee}","${sanitizedCompanyNames}"`
          csvRows.push(row)
        })

        return csvRows.join('\n')
      } else {
        this.toggleOpen()
        return this.errorToast('Az adott csoport feltételei alapján nem találtunk felhasználót.')
      }
    },

    download(data) {
      if (data.length > 0) {
        const blob = new Blob([data], { type: 'text/csv' })

        const url = window.URL.createObjectURL(blob)

        const a = document.createElement('a')

        a.setAttribute('href', url)

        const date = new Date()
        let hours = date.getHours()
        let minutes = date.getMinutes()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()

        const groupName = this.userGroup.groupName.replace(/\s+/g, '_')
        a.setAttribute(
          'download',
          `Vali_${groupName}_rendszeruzenet_levalogatas_${year}${month}${day}-${hours}${minutes}.csv`
        )

        a.click()
      }
    },
    async handleDelete() {
      try {
        await systemEmailsApi.deleteUserGroupById(this.userGroup._id)
        setTimeout(() => {
          this.successToast('Sikeresen törölte a címzett csoportot.')
        }, 500)
        this.closeDeleteModal()
        this.$emit('refresh-list', true)
      } catch (e) {
        console.log(e)
      }
    },
    openDeleteModal() {
      this.$root.$emit('bv::show::modal', this.userGroup._id + '-delete-user-group-modal')
    },
    closeDeleteModal() {
      this.$root.$emit('bv::hide::modal', this.userGroup._id + '-delete-user-group-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-category {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #cce9d8;
  border-radius: 8px;
  border: 1px solid #b2bec3;
  padding: 24px;
  font-size: 20px;
  box-shadow: 0px 2px 8px rgba(99, 110, 114, 0.2);
}

.title {
  font-weight: 700;
  font-size: 20px;
  margin: 0;
}

@media screen and (min-width: 1200px) {
  .title {
    font-size: 24px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .title {
    font-size: 16px;
  }
}
.options-icon {
  position: absolute;
  font-size: 24px;
  right: 30px;
  cursor: pointer;
}
.options-container {
  position: absolute;
  z-index: 999;
  right: 30px;
  top: 50px;
  text-align: left;

  background: #ffffff;
  border: 1px solid #dfe2ea;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 25px rgba(0, 0, 0, 0.07);
  border-radius: 8px;

  width: 250px;
  height: auto;
}

.options-item {
  height: 35px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

.list-icon {
  width: 16px;
  height: 16px;
}

.options-item.delete:hover {
  background: #fbd0d4;
  color: #ba3b46;
}

.options-item.edit:hover {
  background: #ecf0f2;
}
</style>
